<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:80px; padding-bottom:20px;">About the Author</h1>
<p>This is Stephen Morris’ second novel. His first, <em>Memoir,</em> <em>A Novel by Stella Kelly</em>, was published by Austin Macauley in 2019.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?666fbcc8